import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'offer-message-needs-review',
  styleUrl: 'offer-message-needs-review.css',
})
// TODO: Name change needed
export class OfferMessage {
  @Prop() dealerName: string = '';
  @Prop() email: string = '';
  @Prop() isAssigned: boolean = false;
  @Prop() isOfficeClosed: boolean = false;
  @Prop() isFurtherReviewNeeded: boolean = false;
  @Prop() isInspectionNeeded: boolean = false;
  @Prop() isOfferExpired: boolean = false;
  @Prop() offerExpiryDate: string = '';
  @Prop() offerId: string = '';
  @Prop() vehicleShortDescriptions: string = '';
  @Prop() vehicleImageLocation: string = '';
  @Prop() whenReviewClicked = () => {};
  @Prop() whenAppointmentRequested = () => {};
  @Prop() zipCode: string = '';
  @Prop() showOfferPriceButton: boolean = false;
  @Prop() useTradeIn: boolean = false;
  @Prop() tradeInBtnText: string = '';
  @Prop() showIcoQuestionsSection: boolean = true;
  @Prop() vehicle = {
    vin: '',
    yearId: 0,
    makeId: 0,
    modelId: 0,
    trimId: 0,
  };
  @Prop() showKelleyBuysYourCar: boolean = false;

  render() {
    return (
      <div class="mb-14">
        {(this.isOfficeClosed || this.isFurtherReviewNeeded) && (
          <offer-further-review-normal
            offerId={this.offerId}
            email={this.email}
            zipCode={this.zipCode}
            vehicleShortDescription={this.vehicleShortDescriptions}
            whenReviewVehicleDetailsClicked={this.whenReviewClicked}
            useTradeIn={this.useTradeIn}
            tradeInBtnText={this.tradeInBtnText}
            showIcoQuestionsSection={this.showIcoQuestionsSection}
            isOfficeClosed={this.isOfficeClosed}
            showKelleyBuysYourCar={this.showKelleyBuysYourCar}
          />
        )}

        {!this.showKelleyBuysYourCar && this.isInspectionNeeded && (
          <offer-further-review-need-inspection
            offerExpiryDate={this.offerExpiryDate}
            offerId={this.offerId}
            email={this.email}
            zipCode={this.zipCode}
            vehicleShortDescription={this.vehicleShortDescriptions}
            vehicleImageLocation={this.vehicleImageLocation}
            isAssigned={this.isAssigned}
            dealerName={this.dealerName}
            whenAppointmentRequested={this.whenAppointmentRequested}
            whenReviewVehicleDetailsClicked={this.whenReviewClicked}
            showOfferPriceButton={this.showOfferPriceButton}
            useTradeIn={this.useTradeIn}
            tradeInBtnText={this.tradeInBtnText}
            showFurtherReviewTextWithoutDealerName={this.showIcoQuestionsSection}
          />
        )}
      </div>
    );
  }
}
